import { render, staticRenderFns } from "./purchase-plan-reject-confirmation.vue?vue&type=template&id=6dfe8f8a&scoped=true&"
import script from "./purchase-plan-reject-confirmation.vue?vue&type=script&lang=js&"
export * from "./purchase-plan-reject-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./purchase-plan-reject-confirmation.vue?vue&type=style&index=0&id=6dfe8f8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfe8f8a",
  null
  
)

export default component.exports